<template>
  <!-- Importing Profile Component -->
  <ProfileComp></ProfileComp>
</template>
<script>
import ProfileComp from "../../components/Profile/UpdateProfile.vue";

export default {
  name: "Update Profile",
  components: { ProfileComp },
  computed: {},
  mounted() {},
};
</script>
